var zalo = "https://shopfront-cdn.tekoapis.com/static/20f9b470a01bcc4e.svg";

export { zalo as default };
